export enum DashboardTableContentType {
  Unassigned,
  Returned,
  GateQuestions,
}
